<template>
    <!-- Invite New User to the Comapny -->
    <div class="page-layout blank contacts-manage">
        <div class="pb-10">
            <h2 class="headerblock">
                <div class="row">
                    <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
                        <a href="javascript:;" class="btn btn-secondary btn-smm" @click="InviteUser">
                            INVITE
                        </a>
                        <a href="javascript:;" @click="$router.go(-1)"
                            class="btn btn-white btn-smm btn-no-border-blue ml-3"
                            style="color: #00448b;background-color: transparent; box-shadow: none !important;">
                            CANCEL
                        </a>
                    </div>
                    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                        <div class="breadcome-heading d-none d-xl-inline">
                            <div class="form-group formsearch has-warning has-feedback">
                                <input type="text" class="form-control textremove holder" id="inputWarning2"
                                    aria-describedby="inputWarning2Status" placeholder="Search...">
                                <!-- <span class="icon-close-circle-outline form-control-feedback-cancel" aria-hidden="true" ></span> -->
                                <span class="icon-magnify iconsearch form-control-feedback" aria-hidden="true"></span>
                            </div>
                        </div>
                        <router-link :disabled="!$routerHistory.hasForward()"
                            :to="{ path: $routerHistory.next().path }">
                            <el-tooltip class="item pull-right" effect="dark" content="Click to Go Forward"
                                placement="top">
                                <button class="btn btn-new-grey btn-fab-dc mr-3">
                                    <i class="icons icon-arrow-right"></i>
                                </button>
                            </el-tooltip>
                        </router-link>
                        <router-link :disabled="!$routerHistory.hasPrevious()"
                            :to="{ path: $routerHistory.previous().path }">
                            <el-tooltip class="item pull-right" effect="dark" content="Click to Go Back"
                                placement="top">
                                <button class="btn btn-new-grey btn-fab-dc mr-3">
                                    <i class="icons icon-arrow-left"></i>
                                </button>
                            </el-tooltip>
                        </router-link>
                    </div>
                </div>
            </h2>
            <div class="page-layout carded left-sidebar" style="overflow-y: visible;">
                <div class="page-content-wrapper" style="border-radius: 15px;padding: 0px;">
                    <div class="page-content custom-scrollbar pt-4 pb-9 px-1"
                        style="border-radius: 15px;background-color: #d6e2ef !important;">
                        <h5 class="page-content-header-text">INVITE NEW USER TO CRM</h5>
                        <form>
                            <input autocomplete="off" name="hidden" type="text" style="display:none;">
                            <div class="pl-15 pr-15">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="form-group fieldGroup">
                                            <input class="inputField" type="text" data-vv-scope="newEmployee"
                                                data-vv-as="First Name" name="first_name"
                                                :maxlength="maxlengthemployeefirstname" v-model="newEmployee.first_name"
                                                v-validate="'required'" placeholder="Enter First Name">
                                            <span class="highlightInput"></span>
                                            <span class="inputBorder"></span>
                                            <label class="inputLabel fw-600">First Name<sup
                                                    class="prefixIcon">*</sup></label>
                                            <span
                                                class="character-count text-grey">{{maxlengthemployeefirstname - newEmployee.first_name.length}}/20</span>
                                            <span class="invalid-feedback-form text-danger"
                                                style="text-transform: none !important;"
                                                v-show="errors.has('newEmployee.first_name')">{{errors.first('newEmployee.first_name')}}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group fieldGroup">
                                            <input class="inputField" type="text" v-model="newEmployee.middle_name"
                                                placeholder="Enter Middle Name">
                                            <span class="highlightInput"></span>
                                            <span class="inputBorder"></span>
                                            <label class="inputLabel fw-600">Middle Name</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-lg-6 mt-6">
                                        <div class="form-group fieldGroup">
                                            <input class="inputField" type="text" name="last_name"
                                                data-vv-scope="newEmployee" data-vv-as="Last Name"
                                                :maxlength="maxlengthemployeelastname" v-model="newEmployee.last_name"
                                                v-validate="'required'" placeholder="Enter Last Name">
                                            <span class="highlightInput"></span>
                                            <span class="inputBorder"></span>
                                            <label class="inputLabel fw-600">Last Name<sup
                                                    class="prefixIcon">*</sup></label>
                                            <span
                                                class="character-count text-grey">{{maxlengthemployeelastname - newEmployee.last_name.length}}/20</span>
                                            <span class="invalid-feedback-form text-danger"
                                                style="text-transform: none !important;"
                                                v-show="errors.has('newEmployee.last_name')">{{errors.first('newEmployee.last_name')}}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 mt-7">
                                        <div class="form-check form-check-inline">
                                            <label class="form-label-radio text-secondary fw-600">
                                                Gender<sup class="prefixIcon ml-1">*</sup>
                                            </label>
                                        </div>
                                        <div class="preview-elements previewElementsContacts radiooptions mt-2">
                                            <div class="form-check form-check-inline gender-radio">
                                                <label class="form-check-label check-label-dc">
                                                    <input class="form-check-input" :disabled="UserExists"
                                                        data-vv-scope="newEmployee" data-vv-as="Gender"
                                                        v-validate="'required'" type="radio"
                                                        v-model="newEmployee.gender" name="gender"
                                                        :checked="newEmployee.gender=='Male'" selected value="Male">
                                                    <span class="radio-icon"></span>
                                                    <span class="form-check-description fw-600">Male</span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline gender-radio">
                                                <label class="form-check-label check-label-dc">
                                                    <input class="form-check-input" :disabled="UserExists"
                                                        data-vv-scope="newEmployee" data-vv-as="Gender"
                                                        v-validate="'required'" type="radio"
                                                        v-model="newEmployee.gender" name="gender"
                                                        :checked="newEmployee.gender=='Female'" value="Female">
                                                    <span class="radio-icon"></span>
                                                    <span class="form-check-description fw-600">Female</span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline gender-radio">
                                                <label class="form-check-label check-label-dc">
                                                    <input class="form-check-input" :disabled="UserExists"
                                                        data-vv-scope="newEmployee" data-vv-as="Gender"
                                                        v-validate="'required'" type="radio" name="gender"
                                                        value="Others">
                                                    <span class="radio-icon"></span>
                                                    <span class="form-check-description fw-600">Custom</span>
                                                </label>
                                            </div>
                                            <span class="invalid-feedback-form text-danger"
                                                style="text-transform: none !important;"
                                                v-show="errors.has('newEmployee.gender')">{{errors.first('newEmployee.gender')}}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 nt-3" v-if="newEmployee.gender=='Others'">
                                        <span class="text-secondary whiteSpace vselectLabel fw-600">Please Refer to me
                                            as<sup class="prefixIcon ml-1">*</sup></span>
                                        <v-select class="vselect-custom" :disabled="UserExists"
                                            data-vv-scope="newEmployee" v-model="newEmployee.custom_gender.preposition"
                                            v-validate="'required'" required name="preposition"
                                            placeholder="Select Preposition"
                                            :options="['Mr.', 'Mrs.', 'Miss', 'Sir', 'Madam']" style="width: 100%;">
                                        </v-select>
                                        <span class="invalid-feedback-form text-danger"
                                            style="text-transform: none !important;"
                                            v-show="errors.has('newEmployee.preposition')">{{errors.first('newEmployee.preposition')}}</span>
                                    </div>
                                    <div class="col-lg-6 mt-6" v-if="newEmployee.gender=='Others'">
                                        <div class="form-group">
                                            <input class="inputField" :disabled="UserExists" type="text"
                                                data-vv-scope="newEmployee" name="genderptional" data-vv-as="Gender"
                                                v-model="newEmployee.custom_gender.gender" placeholder="Enter Gender">
                                            <span class="inputBorder"></span>
                                            <label class="inputLabel fs-14 fw-600">Gender(Optional)</label>
                                            <span class="invalid-feedback-form text-danger"
                                                v-show="errors.has('newEmployee.genderptional')">{{errors.first('newEmployee.genderptional')}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-6">
                                    <div class="col-lg-6 mt-6">
                                        <div class="form-group fieldGroup">
                                            <input class="inputField" name="primary_email" :disabled="UserExists"
                                                data-vv-scope="newEmployee" data-vv-as="Personal Email"
                                                v-model="newEmployee.primary_email" v-on:blur="checkPrimaryEmail"
                                                v-validate="{required:true,regex: /^([a-z0-9_\-\.]+)@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,3})$/}"
                                                :maxlength="maxlengthemployeeprimaryemail" type="text"
                                                placeholder="Enter Email">
                                            <span class="highlightInput"></span>
                                            <span class="inputBorder"></span>
                                            <label class="inputLabel fw-600" style="top: -1px !important;">Personal
                                                Email<sup class="prefixIcon ml-1">*</sup></label>
                                            <span
                                                class="character-count text-grey">{{maxlengthemployeeprimaryemail - newEmployee.primary_email.length}}/230</span>
                                            <span class="invalid-feedback-form text-danger"
                                                v-if="primaryEmailExists">Personal Email Already Exists!!</span>
                                            <span class="invalid-feedback-form text-danger"
                                                v-if="!primaryEmailValid">Please Enter Valid Personal Email</span>
                                            <span class="invalid-feedback-form text-danger"
                                                style="text-transform: none !important;"
                                                v-show="errors.has('newEmployee.primary_email')">{{errors.first("newEmployee.primary_email")}}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6" style="margin-top: 24px;">
                                        <span class="text-secondary whiteSpace fs-14 fw-600">Phone Number<sup
                                                class="prefixIcon ml-1">*</sup></span>
                                        <vue-tel-input class="teleContact mt-2" id="add_phone_number"
                                            data-vv-scope="newEmployee" data-vv-as="Phone Number" name="phone_number"
                                            v-model="newEmployee.primary_phone.phone_number"
                                            v-on:country-changed="countryChanged($event, 'employee_phone', 0)"
                                            ref="telInput" placeholder="Enter Phone Number" :disabledFormatting="false"
                                            :valid-characters-only="true" v-validate="{required:true,min:15}"
                                            :maxLen="maxPhoneLength" autocomplete="off"></vue-tel-input>
                                        <span class="invalid-feedback-form text-danger"
                                            style="text-transform: none !important;"
                                            v-show="errors.has('newEmployee.phone_number')">{{errors.first("newEmployee.phone_number")}}</span>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        EventBus
    } from "./eventBus/nav-bar-event.js";
    import VueTelInput from "vue-tel-input";

    export default {
        data() {
            return {
                newEmployee: {
                    first_name: "",
                    middle_name: "",
                    last_name: "",
                    primary_email: "",
                    primary_phone: {
                        phone_type: "",
                        phone_number: "",
                        country_code: "",
                        dial_code: "",
                    },
                    gender: "",
                    custom_gender: {
                        gender: "",
                        preposition: "",
                    },
                },
                is_user: true,
                EmailExists: false,
                EmailValid: true,
                UserExists: false,
                maxPhoneLength: 15,
                maxlengthemployeefirstname: 20,
                maxlengthemployeelastname: 20,
                maxlengthemployeeprimaryemail: 230,
                primaryEmailExists: false,
                primaryEmailValid: true,
                country: null,
            };
        },
        props: {
            userData: {},
        },
        created() {
            this.getUserData();
            const dict = {
                custom: {
                    first_name: {
                        required: () => 'First Name is Required'
                    },
                    last_name: {
                        required: () => 'Last Name is Required'
                    },
                    primary_email: {
                        required: () => 'Personal Email is Required',
                        regex: () => 'Please Enter Valid Email',
                    },
                    select_domain: {
                        required: () => "Domain Selection is Required",
                    },
                    email_id: {
                        required: () => 'Business Email is Required',
                        regex: () => 'Please Enter Valid Name'
                    },
                    phone_number: {
                        required: () => "Phone Number is Required",
                        min: () => "Phone Number must Contain more than 9 Numbers",
                        regex: () => "Phone Number must Contain Valid Format"
                    },
                    gender: {
                        required: () => "Gender is Required",
                    },
                    preposition: {
                        required: () => "Please Select Type",
                    },
                }
            }
            this.$validator.localize('en', dict)
        },
        computed: {
            account() {
                return this.$store.getters.account;
            },
            loggedInUser() {
                return this.$store.getters.loggedInUser;
            }
        },
        components: {
            VueTelInput,
        },
        methods: {
            // Dail Code and Country
            countryChanged(country, variable, index) {
                switch (variable) {
                    case 'employee_phone':
                        this.newEmployee.primary_phone.dial_code = country.dialCode
                        this.newEmployee.primary_phone.country_code = country.iso2
                        break
                }
            },
            // Get User Data
            getUserData() {
                if (this.$route.params.id) {
                    this.UserExists = true;
                    this.$http
                        .post("/users/get_user_data", {
                            user_id: this.$route.params.id
                        })
                        .then(response => {
                            if (response.data.status_id == 1) {
                                this.newEmployee = response.data.response;
                                this.newEmployee.email_id = ""
                            }
                        })
                        .catch(error => {
                        });
                }
            },

            // Invite User API
            InviteUser() {
                this.registeredClick = true

                let data = {}
                data = {
                    first_name: this.newEmployee.first_name,
                    middle_name: this.newEmployee.middle_name,
                    last_name: this.newEmployee.last_name,
                    primary_email: this.newEmployee.primary_email,
                    primary_phone: this.newEmployee.primary_phone,
                    gender: this.newEmployee.gender,
                    custom_gender: this.newEmployee.custom_gender,
                    invited_by: this.loggedInUser._id,
                    is_self_registration: false
                }
                this.$validator.validateAll("newEmployee").then(result => {
                    if (result && !this.primaryEmailExists && this.primaryEmailValid) {
                        this.$http
                            .post("/users/register_user", data)
                            .then(res => {
                                this.registeredClick = false
                                if (res.data.status_id == 1) {
                                    // this.$cookie.set("Token", res.data.token, {expires: 7, domain:"digicollect.com"});
                                    // this.$store.commit("setToken", res.data.token);
                                    // window.location.reload();
                                    this.$swal({
                                        title: "Success!",
                                        text: "User Invited Successfully",
                                        type: "success",
                                        confirmButtonText: "OK",
                                        confirmButtonColor: "#005dae",
                                    }).then(() => {
                                        this.$router.go(-1);
                                    });
                                } else {
                                    this.$swal({
                                        title: "Error!",
                                        html: 'Not Able to Invite. Please Contact ' +
                                            '<a href="mailto:helpdesk@digicollect.com" style="color: #00448b">DigiCollect Helpdesk</a>',
                                        type: "error",
                                        confirmButtonText: "OK",
                                        confirmButtonColor: "#005dae",
                                    });
                                }
                            });
                    }
                });
            },

            // Checking Email Exists and Valid
            checkPrimaryEmail() {
                this.$http
                    .post("/check_email_validity", {
                        email_id: this.newEmployee.primary_email,
                        email_type: "personal"
                    })
                    .then(response => {
                        if (response.data.status_id == 1) {
                            this.primaryEmailExists = response.data.exists;
                        }
                    })
                    .catch(error => {
                    });
            },
            // Checking Email Name Exits and Domain Validation and Sending Concatenated Data(Don't Need here)
            checkEmail() {
                this.$http
                    .post("/check_email_validity", {
                        // email_id: this.newEmployee.email_id,
                        email_id: this.newEmployee.email_id.trim() + '@' + this.selecteddomainname.trim(),
                        email_type: "business"
                    })
                    .then(response => {
                        this.EmailExists = response.data.exists;
                        this.EmailValid = response.data.valid;
                    })
                    .catch(error => {
                    });
            },
        },
    };
</script>
<style>
    .previewElements {
        margin-bottom: 11px;
        margin-top: 3px;
    }

    .previewElementsContacts {
        margin-bottom: 2px;
        margin-top: 3px;
    }

    .select:focus {
        border-bottom: solid 1px #00448b !important;
        transition: 0.2s ease all;
        -moz-transition: 0.2s ease all;
        -webkit-transition: 0.2s ease all;
    }

    .selectMap {
        width: 22px;
        height: 22px;
        margin-left: 5px;
        object-fit: contain;
    }

    .socialMedia.dropdown-toggle::after {
        margin-left: 21px;
    }

    .companySelect.v-select input[type="search"] {
        padding: 0 5px !important;
    }

    @-moz-document url-prefix() {
        .inputMedia {
            padding-right: 26px !important;
        }
    }

    .input-group.digi-input-group-dropdown {
        border: 1px solid transparent !important;
    }

    .input-group.digi-input-group-dropdown>.form-control {
        position: relative !important;
        -webkit-box-flex: 1 !important;
        -webkit-flex: 1 1 auto !important;
        -ms-flex: 1 1 auto !important;
        flex: 1 1 auto !important;
        width: 1% !important;
        margin-bottom: 0 !important;
        height: 34px !important;
        padding: 6px 12px 6px 2px !important;
        color: #303031;
        border-bottom: 1px solid #a9aaad !important;
    }

    .input-group.digi-input-group-dropdown .input-group-addon {
        padding-left: 0rem !important;
        padding-right: 0.2rem !important;
        border-bottom: 1px solid #a9aaad !important;
        padding-top: 2px;
        cursor: pointer;
        margin-left: 0px !important;
    }

    .input-group.digi-input-group-dropdown .input-group-append {
        padding-left: 0rem !important;
        padding-right: 0.2rem !important;
        border-bottom: 1px solid #a9aaad !important;
        padding-top: 2px;
        cursor: pointer;
        margin-left: 0px !important;
        height: 34px !important;
    }

    .input-group.digi-input-group-dropdown .input-group-append button.btn.btn-link {
        text-transform: none !important;
        text-decoration: none !important;
        color: #303031 !important;
        height: 34px !important;
        line-height: 34px !important;
        font-weight: 500 !important;
    }

    .overflow-modal.v--modal-overlay .v--modal-box {
        overflow: visible !important;
    }

    .overflow-modal.v--modal-overlay .v--modal-box .v-modal-content {
        border-radius: 15px;
    }

    .overflow-modal.v--modal-overlay .v--modal-box .v-modal-content .v-modal-body {
        overflow: visible;
    }

    .heading-title {
        font-size: 14px;
        font-weight: 600;
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
        background-color: #00448b;
        padding: 20px 24px;
        color: #fff;
        text-transform: uppercase;
        line-height: normal;
        letter-spacing: 0.6px;
        text-align: center;
    }

    #table-app-access thead>tr {
        background: #fff;
    }

    #table-app-access thead tr th {
        text-transform: uppercase;
        color: #00448b;
    }

    #table-app-access thead tr th {
        padding: 16px 10px !important;
        border-bottom: 1px solid #e9ecef;
        vertical-align: middle;
    }

    #table-app-access tbody tr td,
    #table-app-access thead tr th {
        font-size: 13px;
        font-weight: 700;
        line-height: normal;
        letter-spacing: 0.5px;
        padding-left: 24px;
    }

    .table-striped tbody tr:nth-of-type(odd) {
        background-color: #f5f6f9;
    }

    .table-striped tbody tr:nth-of-type(2n) {
        background-color: #fff;
    }

    #table-app-access tbody tr td {
        color: #4e5764;
    }

    #table-app-access tbody tr td {
        padding: 11px 10px !important;
        vertical-align: middle;
    }

    input[type="radio"].radiobutton {
        position: absolute;
        visibility: hidden;
        display: none;
        box-sizing: border-box;
        padding: 0;
    }

    label.label-permissions {
        font-size: 12px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        letter-spacing: normal;
        text-align: center;
        color: #00448b !important;
        cursor: pointer;
        font-weight: bold;
        padding: 6px 14px;
        margin-bottom: 0px;
        margin-right: 0px;
        border: 1px solid #5ca7ec;
        border-radius: 4px;
    }

    input[type="radio"].radiobutton:checked+label.label-permissions {
        color: #fff !important;
        background: #00448b !important;
    }

    .radiooptions .form-check-inline.user-perm .form-check-label {
        width: 120px;
    }

    .radiooptions .form-check-inline.gender-radio .form-check-label {
        width: 66px;
    }

    .switch {
        font-size: 1rem;
        position: relative;
    }

    .switch input {
        position: absolute;
        height: 1px;
        width: 1px;
        background: 0 0;
        border: 0;
        clip: rect(0 0 0 0);
        clip-path: inset(50%);
        overflow: hidden;
        padding: 0;
    }

    .switch input+label {
        position: relative;
        min-width: calc(calc(2.375rem * 0.8) * 2);
        border-radius: calc(2.375rem * 0.8);
        height: calc(2.375rem * 0.8);
        line-height: calc(2.375rem * 0.8);
        display: inline-block;
        cursor: pointer;
        outline: 0;
        user-select: none;
        vertical-align: middle;
        text-indent: calc(calc(calc(2.375rem * 0.8) * 2) + 0.5rem);
    }

    .switch input+label::after,
    .switch input+label::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: calc(calc(2.375rem * 0.8) * 2);
        bottom: 0;
        display: block;
    }

    .switch input+label::before {
        right: 0;
        background-color: #cdd2da;
        border-radius: calc(2.375rem * 0.8);
        transition: 0.2s all;
    }

    .switch input+label::after {
        top: 2px;
        left: 2px;
        width: calc(calc(2.375rem * 0.8) - calc(2px * 2));
        height: calc(calc(2.375rem * 0.8) - calc(2px * 2));
        border-radius: 50%;
        background-color: #fff;
        transition: 0.2s all;
    }

    .switch input:checked+label::before {
        background-color: #00448b;
    }

    .switch input:checked+label::after {
        margin-left: calc(2.375rem * 0.8);
    }

    .switch input:focus+label::before {
        outline: 0;
        box-shadow: 0 0 0 0.2rem rgba(0, 136, 221, 0.25);
    }

    .switch input:disabled+label {
        color: #868e96;
        cursor: not-allowed;
    }

    .switch input:disabled+label::before {
        background-color: #e9ecef;
    }

    .switch.switch-sm {
        font-size: 0.875rem;
    }

    .switch.switch-sm input+label {
        min-width: calc(calc(1.9375rem * 0.8) * 2);
        height: calc(1.9375rem * 0.8);
        line-height: calc(1.9375rem * 0.8);
        text-indent: calc(calc(calc(1.9375rem * 0.8) * 2) + 0.5rem);
    }

    .switch.switch-sm input+label::before {
        width: calc(calc(1.9375rem * 0.8) * 2);
    }

    .switch.switch-sm input+label::after {
        width: calc(calc(1.9375rem * 0.8) - calc(2px * 2));
        height: calc(calc(1.9375rem * 0.8) - calc(2px * 2));
    }

    .switch.switch-sm input:checked+label::after {
        margin-left: calc(1.9375rem * 0.8);
    }

    .switch.switch-lg {
        font-size: 1.25rem;
    }

    .switch.switch-lg input+label {
        min-width: calc(calc(3rem * 0.8) * 2);
        height: calc(3rem * 0.8);
        line-height: calc(3rem * 0.8);
        text-indent: calc(calc(calc(3rem * 0.8) * 2) + 0.5rem);
    }

    .switch.switch-lg input+label::before {
        width: calc(calc(3rem * 0.8) * 2);
    }

    .switch.switch-lg input+label::after {
        width: calc(calc(3rem * 0.8) - calc(2px * 2));
        height: calc(calc(3rem * 0.8) - calc(2px * 2));
    }

    .switch.switch-lg input:checked+label::after {
        margin-left: calc(3rem * 0.8);
    }

    .switch+.switch {
        margin-left: 1rem;
    }

    .page-content-header-text {
        font-size: 15px;
        font-weight: bold;
        line-height: 1.2;
        letter-spacing: 0.64px;
        text-align: center;
        color: #4e5764;
        margin: 20px 20px 30px;
        display: block;
        position: relative;
    }
</style>


// WEBPACK FOOTER //
// src/components/AddNewUser.vue